import { RefinementCtx } from "zod";

export function createAddIssue(ctx: RefinementCtx, ...basePath: string[]) {
  return function (message: string, ...path: string[]) {
    ctx.addIssue({ code: "custom", message, path: [...basePath, ...path] });
  };
}
